<template>
    <div class="container-fluid">
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">Pagar Online</h1>
        </div>
        <div class="row">
            <div class="col-md-8">
                <div class="card mb-4">
                    <div class="card-header">
                        Mis facturas impagas
                    </div>
                    <div class="card-body">
                        <p>Debajo se listan las facturas pendientes de pago. Para generar la orden de pago haga click en "Agregar".</p>
                    </div>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item" v-for="factura in items" :key="factura.id">
                            <div class="d-flex flex-row bd-highlight mb-3">
                                <div class="p-2 flex-grow-1 bd-highlight">Nº: {{ factura.numero_formateado }}<br><small>Vencimiento: {{ factura.vencimiento }}</small></div>
                                <div class="p-2 bd-highlight">$ {{ factura.importe }}</div>
                                <div class="p-2 bd-highlight"><b-button variant="link" @click.prevent="toggleItem(factura)">{{ itemAgregado(factura) ? 'Quitar' : 'Agregar' }}</b-button></div>
                            </div>
                        </li>
                    </ul>
                </div>
                
            </div>
            <div class="col-md-4">
                <div class="card mb-4">
                    <div class="card-header">
                        Resumen
                    </div>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item" v-for="factura in facturas" :key="factura.id">
                            <div class="d-flex flex-row bd-highlight mb-3">
                                <div class="p-2 flex-grow-1 bd-highlight">Nº: {{ factura.numero_formateado }}<br><small>Vencimiento: {{ factura.vencimiento }}</small></div>
                                <div class="p-2 bd-highlight">$ {{ factura.importe }}</div>
                            </div>
                        </li>
                    </ul>
                    <div class="card-body">
                        <h5 class="card-title">Total: $ {{ monto_total }}</h5>
                        <p class="card-text">Al presionar el botón se lo redireccionará a TodoPago para que finalice su transacción.</p>
                        <b-button variant="primary" :disabled="!monto_total" @click.prevent="generarOrdenPago()">Pagar</b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
    middleware: 'auth',
    metaInfo () {
        return { title: 'Pagar Online' }
    },
    computed: {
        monto_total () {
            var total = 0
            for (let index = 0; index < this.facturas.length; index++) {
                const element = this.facturas[index]
                // Sumo el total, menos lo que ya pagó en otra ocasión.
                total += parseFloat(element.importe - element.saldado)
            }
            return total
        },
        items () {
            return this.cuenta_corriente.filter(comprobante => !comprobante.cancelado).map(comprobante => {
                return {
                    id: comprobante.id,
                    numero: comprobante.numero,
                    sucursal: comprobante.sucursal,
                    fecha: comprobante.fecha_emision,
                    vencimiento: comprobante.fecha_1er_vencimiento,
                    pagada: comprobante.cancelado,
                    saldado: parseFloat(comprobante.saldado).toFixed(2),
                    codigo_barras: comprobante.codigo_barras,
                    importe: (parseFloat(comprobante.importe) + parseFloat(comprobante.iva)).toFixed(2),
                    numero_formateado: comprobante.sucursal.toString().padStart(4, '0') + '-' +  comprobante.numero.toString().padStart(8, '0')
                }
            })
        },
        ...mapGetters({
            user: 'auth/user',
            cuentas: 'auth/cuentas',
            cuenta_corriente: 'auth/cuenta_corriente'
        })
    },
    data: () => ({
        facturas: []
    }),
    methods: {
        itemAgregado(factura) {
            return this.facturas.some(comprobante => comprobante.id == factura.id)
        },
        toggleItem(factura) {
            if (this.itemAgregado(factura)){
                this.quitarItem(factura)
            }else {
                this.agregarItem(factura)
            }
        },
        agregarItem(factura) {
            this.facturas.push(factura)
        },
        quitarItem(factura) {
            this.facturas = this.facturas.filter(comprobante => comprobante.id != factura.id)
        },
        async generarOrdenPago() {
            const id = this.user.id;
            const { data: { data } } = await axios.post(`/pagos/generar-cupon/${id}`, this.facturas.map(item => item.id))
            console.log(data)
        }
    }
}
</script>